import { base } from './en/base';
import { pages } from './en/pages';

/** English texts of the module, below its ID: `tenders.nav.tenders`. One file per area. */
export const en = { ...base, ...pages };
